import type { ComponentProps } from 'react';

import { cn } from './cn';
import { fieldControlClass } from './input';

export type TextareaProps = ComponentProps<'textarea'>;

/** Texto longo; cresce com o conteúdo onde o navegador suporta `field-sizing`. */
export function Textarea({ className, rows = 3, ...props }: TextareaProps) {
  return (
    <textarea
      rows={rows}
      data-slot="textarea"
      className={cn(fieldControlClass, 'h-auto min-h-22 py-2.5 [field-sizing:content]', className)}
      {...props}
    />
  );
}
